import { Part } from '@/core/domain/operational/Parts/Parts.types';
import {
  useDeletePartReplacement,
  usePartReplacement,
} from '@/core/domain/operational/PartReplacement/PartReplacement.hooks';
import { ColumnsType } from 'antd/lib/table';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';

import { DeleteIcon, InfiniteTable } from '@/components/_common';
import { getTableScrollX } from '@/utils/table';

const SelectPartReplacementList = () => {
  const { partId } = useRouteMatch<{ partId: string }>().params;

  const { data, isLoading } = usePartReplacement({ partId: +partId });
  const intl = useIntl().formatMessage;

  const { mutateAsync } = useDeletePartReplacement();

  const columns: ColumnsType<Part> = [
    {
      key: 'name',
      dataIndex: 'name',
      title: intl({ id: 'parts.partsReplacement.modal.description' }),
      ellipsis: true,
      width: 210,
    },
    {
      key: 'manufacturingCode',
      dataIndex: 'manufacturingCode',
      title: intl({ id: 'parts.partsReplacement.modal.manufacturingCode' }),
      ellipsis: true,
      width: 150,
    },
    {
      key: 'barCode',
      dataIndex: 'barCode',
      title: intl({ id: 'parts.partsReplacement.modal.barCode' }),
      ellipsis: true,
      width: 150,
    },
    {
      key: 'sku',
      dataIndex: 'sku',
      title: intl({ id: 'parts.partsReplacement.modal.internalCode' }),
      ellipsis: true,
      width: 150,
    },
    {
      key: 'companyCode',
      dataIndex: 'companyCode',
      title: intl({ id: 'parts.partsReplacement.modal.companyCode' }),
      ellipsis: true,
      width: 150,
    },
    {
      key: 'action',
      dataIndex: 'action',
      width: 50,
      align: 'right',
      fixed: 'right',
      render: (_, item) => (
        <DeleteIcon onClick={() => mutateAsync({ replacementId: item.id })} />
      ),
    },
  ];

  return (
    <InfiniteTable
      dataSource={data?.data}
      columns={columns}
      pagination={false}
      loading={isLoading}
      scroll={{ x: getTableScrollX(columns) }}
    />
  );
};

export default SelectPartReplacementList;
